import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useLayoutContext } from 'modules/layout/hooks/useFullscreen'

const Layout = ({ children }: { children: React.ReactNode }) => {
  const { isFullScreen } = useLayoutContext()

  return (
    <Box position="relative" overflowX="auto" style={isFullScreen ? { height: 'auto' } : {}}>
      {children}
    </Box>
  )
}

export default observer(Layout)
